import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var arrow_up_left_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M14 6H6v8h1.5V8.5L17 18l1-1-9.5-9.5H14V6Z" }) });
export {
  arrow_up_left_default as default
};
//# sourceMappingURL=arrow-up-left.js.map
